import React from "react";

export const UserPlus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M16 21v-2a4 4 0 00-4-4H7a4 4 0 00-4 4v2M9.5 11a4 4 0 100-8 4 4 0 000 8M19 8v6M16 11h6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const UserMinus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M16 21v-2a4 4 0 00-4-4H7a4 4 0 00-4 4v2M9.5 11a4 4 0 100-8 4 4 0 000 8M16 11h6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ServerPlus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M3 5h18v6H3zM3 13h18v6H3zM8 8h.01M8 16h.01M17 8h.01M17 16h.01M14 16h6M17 13v6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ServerTrash = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M3 5h18v6H3zM3 13h18v6H3z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M9 9h6M9 17h6M14 3h-4l-1 2H6m12 0h-3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10 15l4 4M14 15l-4 4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M4 6h16M4 12h16M4 18h16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
